import createTheme from '@mui/material/styles/createTheme';

// assets
import colors from '../assets/scss/_themes-vars.module.scss';

// project imports
import { componentStyleOverrides } from './compStyleOverride';
import { themePalette } from './palette';
import { themeTypography } from './typography';

/**
 * Represent theme style and structure as per Material-UI
 * @param {JsonObject} customization customization parameter object
 */
export function theme(customization) {
    const color = colors;

    // let themeOption = {
    //     colors: color,
    //     heading: color.grey900,
    //     paper: color.paper,
    //     backgroundDefault: color.paper,
    //     background: color.primaryLight,
    //     darkTextPrimary: color.grey700,
    //     darkTextSecondary: color.grey500,
    //     textDark: color.grey900,
    //     menuSelected: color.secondaryDark,
    //     menuSelectedBack: color.secondaryLight,
    //     divider: color.grey200,
    //     customization: customization
    // };
    let isDark = customization.mode === 'dark';

    const hostname = window.location.hostname;

    let cor_fundo_principal;
    let cor_fundo_secundario;
    let cor_texto_principal;
    let cor_texto_secundario;
    let cor_texto_dark;
    let cor_papel;

    // 🔹 Define a cor de fundo principal com base no subdomínio
    if (hostname.startsWith('erp.glazzbeauty')) {
        cor_fundo_principal = isDark ? color.paper : '#F9BED1';
        cor_fundo_secundario = isDark ? color.primaryLight : '#FDE8EF';
        cor_texto_principal = isDark ? color.grey700 : '#E34174';
        cor_texto_secundario = isDark ? '#9ca3af' : '#EE8EAD';
        cor_texto_dark = isDark ? color.grey900 : '#E9165C';
        cor_papel = isDark ? color.paper : '#F9BED1';
    } else if (hostname.startsWith('erp.quimicer')) {
        cor_fundo_principal = isDark ? '#000000' : color.paper;
        cor_fundo_secundario = isDark ? '#0b0b1a' : color.primaryLight;
        cor_texto_principal = isDark ? '#969696' : color.grey700;
        cor_texto_secundario = isDark ? '#aaaaaa' : '#9ca3af';
        cor_texto_dark = isDark ? '#ffffff' : color.grey900;
        cor_papel = isDark ? '#1e1e2f' : color.paper;
    } else if (hostname.startsWith('erp.bliveinpets')) {
        cor_fundo_principal = isDark ? '#000000' : color.paper;
        cor_fundo_secundario = isDark ? '#0b0b1a' : color.primaryLight;
        cor_texto_principal = isDark ? '#969696' : color.grey700;
        cor_texto_secundario = isDark ? '#aaaaaa' : '#9ca3af';
        cor_texto_dark = isDark ? '#ffffff' : color.grey900;
        cor_papel = isDark ? '#1e1e2f' : color.paper;
    } else {
        // fallback
        cor_fundo_principal = isDark ? '#101624' : color.paper;
        cor_fundo_secundario = isDark ? '#1d273b' : color.primaryLight;
        cor_texto_principal = isDark ? '#969696' : color.grey700;
        cor_texto_secundario = isDark ? '#aaaaaa' : '#9ca3af';
        cor_texto_dark = isDark ? '#ffffff' : color.grey900;
        cor_papel = isDark ? '#1e1e2f' : color.paper;
    }

    let themeOption = {
        colors: {
            ...color,

            grey50: '#fafafa',
            grey100: '#f5f5f5',
            grey200: '#eeeeee',
            grey300: '#e0e0e0'
        },

        heading: isDark ? '#ffffff' : color.grey900,
        paper: cor_papel,

        backgroundDefault: cor_fundo_principal, //Boas opcoes: #1b1c1d / #101624    // AS DUAS CORES PRINCIPAIS DO SISTEMA, USADAS EM FUNDO, PAPER E BACKGROUND
        background: cor_fundo_secundario, //Boas opcoes: #282a2c / #1d273b   // AS DUAS CORES PRINCIPAIS DO SISTEMA, USADAS EM FUNDO, PAPER E BACKGROUND

        darkTextPrimary: cor_texto_principal, //COR DA FONTE PRINCIPAL
        // darkTextPrimary: isDark ? '#e0e0e0' : '#9ca3af',
        // darkTextSecondary: isDark ? '#aaaaaa' : color.grey500,
        darkTextSecondary: cor_texto_secundario,

        textDark: cor_texto_dark,

        menuSelected: color.secondaryDark,
        // menuSelectedBack: isDark ? 'rgba(255, 255, 255, 0.08)' : color.secondaryLight,
        menuSelectedBack: isDark ? 'rgba(255,255,255,0.06)' : color.secondaryLight,

        divider: isDark ? 'rgba(255,255,255,0.12)' : color.grey200,

        customization: customization
    };

    return createTheme({
        direction: 'ltr',
        palette: themePalette(themeOption),
        mixins: {
            toolbar: {
                minHeight: '48px',
                padding: '16px',
                '@media (min-width: 600px)': {
                    minHeight: '48px'
                }
            }
        },
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 960,
                lg: 1280,
                xl: 1920
            }
        },
        typography: themeTypography(themeOption),
        components: componentStyleOverrides(themeOption)
    });
}

export default theme;

// export function theme(customization) {
//     const mode = customization?.mode || 'light';

//     let baseTheme = createTheme({
//         palette: {
//             mode,
//             primary: {
//                 main: customization?.primaryColor || '#1976d2',
//                 light: '#42a5f5',
//                 dark: '#1565c0'
//             },
//             secondary: {
//                 main: '#9c27b0',
//                 light: '#ba68c8', // 🔥 FORÇADO
//                 dark: '#7b1fa2' // 🔥 FORÇADO
//             },
//             background: {
//                 default: mode === 'dark' ? '#0f172a' : '#f5f7fb',
//                 paper: mode === 'dark' ? '#111827' : '#ffffff'
//             }
//         },
//         shape: {
//             borderRadius: customization?.borderRadius || 12
//         },
//         typography: {
//             fontFamily: customization?.fontFamily || "'Roboto', sans-serif"
//         }
//     });

//     // NÃO confia só no MUI → força fallback
//     baseTheme.palette.secondary.light = baseTheme.palette.secondary.light || '#ba68c8';

//     baseTheme.palette.secondary.dark = baseTheme.palette.secondary.dark || '#7b1fa2';

//     baseTheme.components = componentStyleOverrides(baseTheme);

//     return baseTheme;
// }

// export default theme;
